
export default {
  data () {
    return {
      openKeys: ['s0']
    }
  },
  methods: {
    onCollapse (collapsed, type) {
      console.log(collapsed, type)
    },
    onBreakpoint (broken) {
      console.log(broken)
    },
    logout () {
      sessionStorage.clear()
      this.$router.push('/admin/login')
    },
    onOpenChange (openKeys) {
      const latestOpenKey = openKeys.find(
        key => this.openKeys.indexOf(key) === -1
      )
      //   if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      //     this.openKeys = openKeys
      //   } else {
      this.openKeys = latestOpenKey ? [latestOpenKey] : []
    //   }
    },
    goTo (obj) {
      this.$router.push(obj.menu_link)
    }
  },
  created () {
    this.openKeys = [this.$route.meta.group]
    this.setUser()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/slider.js